import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import LoginComponent, { LoginComponentProps } from 'src/modules/modals/login/Login.component';
import { RootState } from 'src/reducers/RootReducer';
import Authentication from 'src/value-objects/Authentication';
import { login, LoginAction, loginClearErrors, logout } from 'src/actions/authentication/login/Login.actions';
import * as loginTypes from 'src/actions/authentication/login/Types';
import { Action } from 'redux';
import { openModal, OpenModal } from 'src/actions/modal';
import RegisterContainer from 'src/modules/modals/register/Register.container';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import { getUser, GetUserAction } from 'src/actions/user/get/GetUser.actions';
import PasswordRecoveryContainer from '../password-recovery/PasswordRecovery.container';

interface StateProps {
  error: boolean;
  errorMessage: {};
  userId?: number;
}

interface DispatchProps {
  login: (credentials: Authentication) => Promise<LoginAction>;
  logout: () => LoginAction;
  loginClearErrors: () => LoginAction;
  openModal: (content: JSX.Element) => void;
  getUser(userId: number): Promise<GetUserAction>;
}

interface Props extends StateProps, DispatchProps {
  modalRef?: Modal;
}

interface State {
  rememberMe: boolean;
  password: string;
  email: string;
}

class LoginContainer extends React.Component<Props, State> {

  constructor (props: Props) {
    super(props);
    this.props.loginClearErrors();
    this.state = {
      email: '',
      password: '',
      rememberMe: false
    };
  }

  public render(): React.ReactNode {
    return <LoginComponent {...this.getComponentProps()}/>;
  }

  private handleChange(key: string): (value: string | boolean) => void {
    return (value: string | boolean) => {
      const newState = {};
      newState[key] = value;
      this.setState(newState);
    };
  }

  private handleSubmit(): void {
    this.props.login(this.state).then((response: Action) => {
      if (response.type === loginTypes.LOGIN_SUCCESS) {
        this.props.getUser(this.props.userId!);
        this.props.modalRef!.modal('hide');
        window.location.reload();
      }
    });
  }

  private register(): void {
    this.props.openModal(
      <RegisterContainer/>
    );
  }
  
  private passwordRecovery(): void {
    this.props.openModal(
      <PasswordRecoveryContainer/>
    );
  }

  private getComponentProps(): LoginComponentProps {
    return {
      handleChange: (key: string) => this.handleChange(key),
      handleSubmit: () => this.handleSubmit(),
      register: () => this.register(),
      passwordRecovery: () => this.passwordRecovery(),
      rememberMe: this.state.rememberMe,
      error: this.props.error,
      errorMessage: this.props.errorMessage,
      modalRef: this.props.modalRef!,
    };
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>
): DispatchProps => {

  return {
    login: (credentials: Authentication): Promise<LoginAction> => {
      return dispatch(login(credentials));
    },
    logout: (): LoginAction => {
      return dispatch(logout());
    },
    loginClearErrors: (): LoginAction => {
      return dispatch(loginClearErrors());
    },
    openModal: (content: JSX.Element): OpenModal => {
      return dispatch(openModal(content));
    },
    getUser: (userId: number): Promise<GetUserAction> => {
      return dispatch(getUser(userId));
    }
  };
};

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  error: state.authentication.loginError,
  errorMessage: state.authentication.errorMessage,
  userId: state.authentication.loggedUserData || undefined,
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);


// WEBPACK FOOTER //
// ./src/modules/modals/login/Login.container.tsx